import { createRouter, createWebHistory } from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import pages from './routes/pages'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'dashboard' } },
    ...apps,
    ...dashboard,
    ...pages,
    {
      path: '/:pathMatch(.*)*',
      redirect: 'error-404',
    },
  ],
})

const addLegacyCurrentRouteAccessors = routerInstance => {
  const currentRouteRef = routerInstance?.currentRoute

  if (!currentRouteRef || typeof currentRouteRef !== 'object') return

  const defaultValues = {
    params: {},
    query: {},
    meta: {},
    matched: [],
  }

  ;['params', 'query', 'path', 'name', 'meta', 'matched', 'fullPath', 'hash'].forEach(key => {
    const descriptor = Object.getOwnPropertyDescriptor(currentRouteRef, key)

    if (descriptor && descriptor.configurable === false) return

    Object.defineProperty(currentRouteRef, key, {
      configurable: true,
      enumerable: false,
      get() {
        return currentRouteRef.value?.[key] ?? defaultValues[key]
      },
    })
  })
}

addLegacyCurrentRouteAccessors(router)

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {

    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  } else if (!to.meta.redirectIfLoggedIn && !isLoggedIn) {
    return next({ name: 'auth-login' })
  }

  // Redirect if logged in Get Invoice
  if (to.meta.redirectIfLoggedInGetInvoice && isLoggedIn) {
    return next({ name: 'logged-get-invoice', params: {token: to.params.token} })
  }

  // Redirect if logged in Verify Email
  if(to.meta.redirectIfLoggedInVerifyEmail && isLoggedIn && !to.meta.allowAuthenticated) {
    return next({ name: 'logged-verify-email', params: {token: to.params.token} })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn && !to.meta.allowAuthenticated) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
